/**
 * Keeps the theme's product price panel in sync with the running add-on
 * total shown by the Globo Product Options app. Globo computes its own
 * add-on delta (in `.gpo-total-text`) but never touches the theme's price
 * markup, since this theme's price panel uses custom, non-standard classes
 * Globo doesn't auto-detect. This mirrors that delta into either a
 * separate "Total price" line (main panel), or a single merged number
 * that replaces the base price outright (sticky bar, via
 * `data-price-merge`).
 */
(function () {
  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return null;

    var withDecimals = cleaned.match(/^(\d[\d.,]*?)[.,](\d{2})$/);
    if (withDecimals) {
      var intPart = withDecimals[1].replace(/[.,]/g, '');
      return parseInt(intPart + withDecimals[2], 10);
    }

    var digitsOnly = cleaned.replace(/[.,]/g, '');
    if (!digitsOnly) return null;
    return parseInt(digitsOnly, 10) * 100;
  }

  function formatCents(cents) {
    var format = (window.cartStrings && window.cartStrings.money_format) || window.Shopify.money_format;
    return window.Shopify.formatMoney(cents, format);
  }

  function getAddonCents() {
    var addonEl = document.querySelector('.gpo-total-text, .gpo-total .gpo-total-text');
    return addonEl ? parseMoneyToCents(addonEl.textContent) : null;
  }

  function syncMerged(container, baseCents, addonCents) {
    var valueEl = container.querySelector('[data-price-merge-value]');
    if (!valueEl || baseCents == null) return;
    valueEl.textContent = formatCents(baseCents + (addonCents || 0));
  }

  function syncSeparate(container, baseCents, addonCents) {
    var totalRow = container.querySelector('[data-price-addon-total]');
    var totalValueEl = container.querySelector('[data-price-addon-total-value]');
    if (!totalRow || !totalValueEl) return;

    if (baseCents == null || !addonCents) {
      totalRow.hidden = true;
      return;
    }

    totalValueEl.textContent = formatCents(baseCents + addonCents);
    totalRow.hidden = false;
  }

  function syncContainer(container) {
    var baseEl = container.querySelector('.price__regular .price');
    if (!baseEl) return;

    var baseCents = parseMoneyToCents(baseEl.textContent);
    var addonCents = getAddonCents();

    if (container.hasAttribute('data-price-merge')) {
      syncMerged(container, baseCents, addonCents);
    } else {
      syncSeparate(container, baseCents, addonCents);
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-price-addon-sync]').forEach(syncContainer);
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  new MutationObserver(scheduleSync).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true
  });

  /**
   * The theme's own sticky-bar reveal script watches the main Add to Cart
   * button via IntersectionObserver, but Globo Product Options clones that
   * button after load (for its own pre-submit validation), leaving the
   * theme's captured reference pointing at a detached node — the observer
   * then never fires again (or fires erratically and removes its own
   * "sticky-addcart-show" class right after we add it). This reveals the
   * bar from scroll position against a stable anchor Globo doesn't touch,
   * using our own class name so the theme's broken script can't fight it.
   */
  function initStickyReveal() {
    var bar = document.getElementById('bls__sticky-addcart');
    var anchor = document.querySelector('.bls__pdp-price-shell') || document.querySelector('[data-price-addon-sync]');
    if (!bar || !anchor) return;

    var ticking = false;
    function update() {
      ticking = false;
      var show = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('js-sticky-visible', show);
      document.body.classList.toggle('js-sticky-visible', show);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyReveal);
  } else {
    initStickyReveal();
  }
})();
